import { inject, Injectable } from "@angular/core";
import { UrlService } from "../../../../environments/urlService";
import { HttpClient, HttpContext } from "@angular/common/http";
import { UserCompleteRegistrationDTO } from "../dto/UserCompleteRegistrationDTO";
import { Observable } from "rxjs";
import { IS_SPINNER_ACTIVE } from "../../../util/interceptors";
import { VideoShowDto } from "../dto/VideoShowDto";

@Injectable({
  providedIn: 'root',
})
export class UserBackendService {
  private readonly url: string;
  private readonly settingsUrl: string;

  private urlService = inject(UrlService);
  private http = inject(HttpClient);

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'user/';
    this.settingsUrl = this.urlService.getModelsUserSettingsUrl();
  }

  completeRegistration(data: UserCompleteRegistrationDTO): Observable<void> {
    return this.http.post<void>(this.url + 'complete-registration', data, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }

  updateViewSettings(data: VideoShowDto): Observable<void> {
    return this.http.put<void>(this.settingsUrl + 'video-show', data, {
      context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
      withCredentials: true,
    });
  }
}
